import {useCallback, useEffect, useLayoutEffect, useRef} from 'react';

type Options = {
    /** Dependency that triggers scroll on change (e.g. messages.length) */
    triggerDep: any;
    /** When true, scrolling is suppressed (e.g. while loading) */
    disabled?: boolean;
    /** Bottom spacing in px added to the scroll anchor element */
    bottomSpacing?: number;
};

export function useScrollToBottom({triggerDep, disabled, bottomSpacing = 0}: Options) {
    const messagesEndRef = useRef<HTMLDivElement>(null);

    const scrollToBottom = useCallback(() => {
        const el = messagesEndRef.current;
        if (!el) {
            return;
        }
        const container = el.closest('[class*="overflow-y"]') || el.parentElement;
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }, []);

    // Apply bottom spacing to the anchor element
    useEffect(() => {
        if (messagesEndRef.current && bottomSpacing > 0) {
            messagesEndRef.current.style.height = `${bottomSpacing}px`;
        }
    }, [bottomSpacing, triggerDep]);

    // Scroll when content changes
    useEffect(() => {
        if (!disabled && triggerDep) {
            scrollToBottom();
        }
    }, [disabled, triggerDep, scrollToBottom]);

    // Scroll on initial mount
    useLayoutEffect(() => {
        if (messagesEndRef.current) {
            scrollToBottom();
        }
    }, [scrollToBottom]);

    return {messagesEndRef, scrollToBottom};
}
